import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const sections = [
  {
    title: 'Medical Course',
    columns: ['Sl No.', 'Name', 'College', 'City', 'Course'],
    rows: [
      ['1', 'C S DEEPSHIKA', 'VYDEHI INSTITUTE OF MEDICAL SCIENCE AND RESEARCH CENTRE', 'BENGALURU', 'MBBS'],
      ['2', 'MANJOT SINGH SETHI', "ST. JOHN'S MEDICAL COLLEGE", 'BANGALORE', 'MBBS'],
      ['3', 'ANANYA ASHOK', 'KS HEGDE MEDICAL ACADEMY', 'MANGALORE', 'MBBS'],
      ['4', 'NIHARIKA V', 'KASTURBA MEDICAL COLLEGE MANIPAL', 'MANIPAL', 'MBBS'],
      ['5', 'NANDANA RAJESH', 'PARISHRAMA NEET ACADEMY', 'BANGALORE', 'MEDICINE'],
      ['6', 'DAHLIA SUSAN BINO', 'FATHER MULLER MEDICAL COLLEGE', 'MANGALORE, KARNATAKA', 'MEDICINE'],
      ['7', 'DEEKSHITHA MALLADA', 'SIDDHARTHA MEDICL COLLEGE', 'TUMKUR', 'MEDICINE'],
    ],
  },
  {
    title: 'Other Professional Courses',
    columns: ['Sl No.', 'Name', 'College', 'City', 'Course'],
    rows: [
      ['1', 'M.S.TARAN', 'M.S.Ramaiah', 'Bangalore', 'Data science and analytics'],
      ['2', 'AVIK PRASANNA MUKHERJEE', 'SYMBIOSIS PUNE', 'PUNE', 'Bsc. Economics (hons)'],
      ['3', 'OINDRILA BHATTACHARYYA', 'SHIV NADAR UNIVERSITY NOIDA', 'NOIDA', 'BSc. REASEARCH CHEMISTRY'],
      ['4', 'S PRANATI RAO', 'RV UNIVERSITY', 'BENGALURU', 'BBA.LLB'],
      ['5', 'SUSHMA RAJ', 'PES UNIVERSITY', 'BANGALORE', 'BBA - BUSINESS ANALYTICS'],
      ['6', 'DISHITA MITTAL', 'JINDAL GLOBAL LAW SCHOOL', 'SONIPAT', 'LAW -BCOM LLB(HONS)'],
      ['7', 'DHRITI A BENGALORE', 'INDIAN INSTITUTE OF SCIENCE EDUCATION AND RESEARCH', 'TIRUVANANTHAPURAM', 'BS-MS DUAL DEGREE'],
      ['8', 'ARJUN HALDIPUR', 'RASHTREEYA VIDYALAYA (RV UNIVERSITY)', 'BENGALURU', 'BACHELOR OF DESIGN'],
      ['9', 'VARSHINI', 'BMS COLLEGE OF ARCHITECTURE', 'BANGALORE', 'BACHELORS OF ARCHITECTURE'],
      ['10', 'UPPULURI GAURAV SATYAVEER SHASHANK', 'AZIM PREMJI UNIVERSITY, BANGALORE', 'BANGALORE', 'BACHELORS IN SCIENCE - PHYSICS (HONORS)'],
      ['11', 'ANN JACOB', 'CHRIST UNIVERSITY', 'BANGALORE', 'BCOM HONS'],
      ['12', 'KRISHNA KARNANI', 'CHRIST', 'BANGALORE', 'BBA(HONS.) - CHRIST KORMANGALA'],
      ['13', 'HASMITHA NAGARAJ', 'ST JOSEPHS UNIVERSITY', 'BENGALURU', 'BA PSYCHOLOGY AND OPTIONAL ENGLISH'],
      ['14', 'ARUNIMA GANGULY', 'MANIPAL UNIVERSITY', 'BANGALORE', 'BA ECONOMICS, POLITICAL SCIENCE'],
      ['15', 'YASHAS PRASHANTH', 'T A PAI MANAGEMENT INSTITUTE', 'BENGALURU', 'B B A HONOURS'],
      ['16', 'TANISHQ V JAIN', 'CENTER FOR MANAGEMENT STUDIES', 'BANGALORE', 'CORPORATE BBA'],
      ['17', 'VISMAY B TEEKA', 'CHRIST UNIVERSITY', 'BANGALORE', 'BACHELORS IN BUSINESS ADMINISTRATION'],
      ['18', 'ADITHYA S Nair', 'CHRIST University', 'KARNATAKA', 'BBA FINANCE AND INTERNATIONAL BUSINESS'],
      ['19', 'AADITH GOPAL', "ST JOSEPH'S COLLEGE", 'BENGALURU', 'BBA'],
      ['20', 'ANGELA ELSA JONIE', 'DELHI UNIVERSITY', 'DELHI', 'BCom'],
      ['21', 'HIMANGI PAMECHA', 'MANIPAL UNIVERSITY', 'BENGALURU', 'BBA(Hons)'],
      ['22', 'KHUSH BAID', 'CMS LALBAGH ROAD', 'BENGALURU', 'BBA'],
      ['23', 'M KAUSHIK', 'CHRIST COLLEGE, YESHWANTHPUR', 'BENGALURU', 'BBA'],
      ['24', 'MANTHAN C S', 'STRATE SCHOOL OF DESIGN', 'BENGALURU', 'Bachelor of Design'],
      ['25', 'PIYUSH R', 'CHRIST COLLEGE, DAIRY CIRCLE', 'BENGALURU', 'BCom (Hons)'],
    ],
  },
  {
    title: 'Engineering Courses',
    columns: ['Sl No.', 'Name', 'College', 'City', 'Course'],
    rows: [
      ['1', 'M PRATHAM KAMATH', 'BITS PILANI KK BIRLA GOA CAMPUS', 'GOA', 'MECHANICAL ENGINEERING'],
      ['2', 'SURYA P', 'PES UNIVERSITY', 'BENGALURU', 'COMPUTER SCIENCE ENGINEERING'],
      ['3', 'ARNAV AMIT AMBEKAR', 'UNIVERSITY OF VISVESVARAYA COLLEGE OF ENGINEERING', 'BANGALORE', 'ELECTRONICS AND COMMUNICATION'],
      ['4', 'RASHI JAJODIA', 'RV UNIVERSITY', 'BANGALORE', 'B TECH. (HONS.) IN COMPUTER SCIENCE AND ENGINEERING'],
      ['5', 'S RIJUTHA', 'SRI VENKATESHWARA COLLEGE OF ENGINEERING', 'BANGALORE', 'COMPUTER SCIENCE AND ENGINEERING'],
      ['6', 'DEEPIKA B RAMAN', 'PES UNIVERSITY', 'BANGALORE', 'COMPUTER SCIENCE WITH AI & ML'],
      ['7', 'ISHA RAJMOHAN', 'DAYANAND SAGAR COLLEGE OF ENGINEERING', 'BANGALORE', 'COMPUTER SCIENCE ENGINEERING'],
      ['8', 'GOUTHAM ALAPATY', 'RAMAIAH INSTITUTE OF TECHNOLOGY', 'BANGALORE', 'MECHANICAL ENGINEERING'],
      ['9', 'VIBHA SABAREESAN', 'JAIN UNIVERSITY - FET', 'BENGALURU', 'COMPUTER SCIENCE ENGINEERING'],
      ['10', 'M S ANANYA', 'MANIPAL INSTITUTE OF TECHNOLOGY', 'BANGALORE', 'INFORMATION TECHNOLOGY'],
      ['11', 'M A TARA', 'PES UNIVERSITY EC CAMPUS', 'BANGALORE', 'COMPUTER SCIENCE ENGINEERING'],
      ['12', 'MAHIKA PATNEY', 'PES UNIVERSITY, EC CAMPUS', 'BANGALORE', 'COMPUTER SCIENCE ENGINEERING'],
      ['13', 'ROSE SINGH BISEN', 'PES UNIVERSITY (RING ROAD CAMPUS)', 'BENGALURU', 'BTECH COMPUTER SCIENCE ENGINEERING'],
      ['14', 'NAVTEJ R', 'VIT VELLORE', 'VELLORE', 'MECHANICAL MAJOR, CS MINOR'],
      ['15', 'PAVITHRA MANIKANDAN', 'BMS COLLEGE OF ENGINEERING', 'BENGALURU', 'COMPUTER SCIENCE ENGINEERING-DATA SCIENCES'],
      ['16', 'MEDHANSH MOHAN RAM', 'BMS INSTITUTE OF TECHNOLOGY', 'BANGLORE', 'ELECTRONICS AND COMMUNICATION'],
      ['17', 'ABHAY B S', 'BMS COLLEGE OF ENGINEERING', 'BANGALORE', 'ELECTRONICS AND COMMUNICATION ENGINEERING'],
      ['18', 'TRINATH BHATTACHARYA', 'SAI VIDYA INSTITUTE OF TECHNOLOGY', 'BENGALURU', 'COMPUTER SCIENCE AND ENGINEERING'],
      ['19', 'JOVIKA SUJITH', 'BMS INSTITUTE OF TECHNOLOGY AND MANAGEMENT', 'BANGALORE', 'INFORMATION SCIENCE'],
      ['20', 'LEKHA PAYASVINI SATNUR', 'BMS INSTITUTE OF TECHNOLOGY', 'BENGALURU', 'INFORMATION SCIENCE'],
      ['21', 'ANVITHA K', 'ALLIANCE UNIVERSITY', 'BANGALORE', 'BTech CSE'],
      ['22', 'REEMA KASHYAP', 'MS RAMAIAH UNIVERSITY OF APPLIED SCIENCES', 'BANGALORE', 'INFORMATION SCIENCE'],
      ['23', 'BHAVYA PATHAK', 'MONASH UNIVERSITY', 'MELBOURNE, AUSTRALIA', 'BACHELOR OF ENGINEERING (HONOURS)'],
      ['24', 'YUVAN GOWDA', 'PORTLAND STATE UNIVERSITY', 'USA', 'COMPUTER ENGINEERING'],
      ['25', 'ADITYA KUMAR ANIL', 'KALINGA INSTITUTE', 'BHAUBANESHWAR', 'BE COMPUTER SCIENCE'],
      ['26', 'DIYA PAI', 'BMS IT', 'BANGALORE', 'BE COMPUTER SCIENCE'],
      ['27', 'KARTHIK G KAMATH', 'DAYANAND SAGAR COLEEGE', 'BANGALORE', 'BE COMPUTER SCIENCE'],
      ['28', 'PARTH AGARWAL', 'BMS IT', 'BANGALORE', 'BE (MECHANICAL)'],
      ['29', 'SUKUMAR B V', 'CAMBRIDGE INSTITUTE OF TECHNOLOGY', 'BANGALORE', 'BTech (AI ML)'],
      ['30', 'TRINAV PRASAD TALUKDAR', 'LAKSHA UNIVERSITY', 'CHANDIGARH', 'BE'],
    ],
  },
];

const Features = () => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 200 }} aria-label="alumni placements table">
        <TableBody>
          {sections.map((section) => (
            <React.Fragment key={section.title}>
              <TableRow>
                <TableCell colSpan={5} sx={{ py: 1 }}>
                  <Typography align="center" variant="h5" fontWeight={700}>
                    {section.title}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                {section.columns.map((column) => (
                  <TableCell key={column} sx={{ fontWeight: 700 }}>
                    <Typography variant="subtitle2" fontWeight={700} align={column === 'Sl No.' ? 'center' : 'left'}>
                      {column}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
              {section.rows.map((row) => (
                <TableRow key={`${section.title}-${row[0]}-${row[1]}`}>
                  {row.map((cell, index) => (
                    <TableCell key={`${section.title}-${row[0]}-${index}`}>
                      <Typography
                        color="text.secondary"
                        variant="subtitle2"
                        align={index === 0 ? 'center' : 'left'}
                      >
                        {cell}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Features;
